export default __webpack_public_path__ + "img/citroen-logo.e4f89b4e.png";